import React, {useEffect, useState} from "react";
import Style from '../styles/Services.module.css';

function ImageBlock({ beforeImage, afterImage, name }) {
  const [sliderValue, setSliderValue] = useState(50);
  const [isUserControlled, setIsUserControlled] = useState(false);
  const [isPreviewing, setIsPreviewing] = useState(false);

  useEffect(() => {
    if (isUserControlled || !isPreviewing) {
      return undefined;
    }

    let frameId;
    const startedAt = Date.now();

    const animate = () => {
      const elapsed = (Date.now() - startedAt) / 1200;
      const nextValue = 50 + Math.sin(elapsed) * 34;
      setSliderValue(Math.round(nextValue));
      frameId = window.requestAnimationFrame(animate);
    };

    frameId = window.requestAnimationFrame(animate);

    return () => window.cancelAnimationFrame(frameId);
  }, [isPreviewing, isUserControlled]);
  
  const handleSliderChange = (event) => {
      setSliderValue(Number(event.target.value));
      setIsUserControlled(true);
    };

  const handleAutoCompare = () => {
      setIsUserControlled(false);
      setIsPreviewing(true);
  }
  
    return (
      <div className={Style.Content4Img}>
        <div className={Style.ImgContainer}>
          <div
            className={Style.ImgBlock}
            onMouseEnter={() => !isUserControlled && setIsPreviewing(true)}
            onMouseLeave={() => setIsPreviewing(false)}
            onFocus={() => !isUserControlled && setIsPreviewing(true)}
            onBlur={() => setIsPreviewing(false)}
          >
            <div className={Style.BeforeAfterContainer}>
              <img
                className={Style.BeforeImage}
                src={beforeImage}
                alt="Before"
                loading="lazy"
                decoding="async"
                width="640"
                height="420"
              />
              <div className={Style.AfterReveal} style={{ clipPath: `inset(0 0 0 ${sliderValue}%)` }}>
                <img
                  className={Style.AfterImage}
                  src={afterImage}
                  alt="After"
                  loading="lazy"
                  decoding="async"
                  width="640"
                  height="420"
                />
              </div>
              <div className={Style.CompareHandle} style={{ left: `${sliderValue}%` }}>
                <span></span>
              </div>
              <div className={Style.CompareLabels}>
                <span>Before</span>
                <span>After</span>
              </div>
              <div className={`${Style.Overlay}`}></div>
              <input
                className={Style.Slider}
                type="range"
                min="0"
                max="100"
                step="1"
                value={sliderValue}
                onChange={handleSliderChange}
                aria-label="Compare before and after project photos"
              />
            </div>
            {isUserControlled && (
              <button className={Style.AutoCompareButton} type="button" onClick={handleAutoCompare}>
                Auto compare
              </button>
            )}
          </div>
        </div>
        <div className={Style.ImgName}>
          <h3>{name}</h3>
        </div>
    </div>
    );
  }
  export default ImageBlock;
